function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "iconfinder_Update_984748",
  transform: "translate(-16.5 -14.919)"
}, React.createElement("path", {
  id: "Path_415",
  "data-name": "Path 415",
  d: "M18.22,73.6h0l0,.006c0,.017,0,.033.007.049s0,0,0,.008l.662,4.3a.956.956,0,0,0,1.889-.291l-.1-.668c.12.1.241.2.366.289A8.255,8.255,0,0,0,33.928,72.68l-2.607-.718A5.557,5.557,0,0,1,22.642,75.1c-.142-.1-.277-.216-.408-.333l.756.073a.959.959,0,0,0,.184-1.9l-3.985-.386a.9.9,0,0,0-.937.705c-.008.031-.013.063-.018.1s-.01.043-.012.066c0,.007,0,.013,0,.019,0,.029,0,.059,0,.089S18.218,73.575,18.22,73.6Z",
  transform: "translate(-1.428 -47.436)",
  fill: "#0cd581"
}), React.createElement("path", {
  id: "Path_416",
  "data-name": "Path 416",
  d: "M32.208,20.21h0l0-.006c0-.017,0-.033-.007-.049s0,0,0-.007l-.662-4.3a.956.956,0,0,0-1.889.291l.1.668c-.12-.1-.241-.2-.367-.289A8.254,8.254,0,0,0,16.5,21.127l2.607.717A5.557,5.557,0,0,1,27.786,18.7c.142.1.277.216.408.333l-.756-.073a.959.959,0,0,0-.184,1.9l3.985.386a.9.9,0,0,0,.937-.705.931.931,0,0,0,.018-.1c0-.022.011-.043.013-.066,0-.006,0-.013,0-.019a.876.876,0,0,0,0-.089C32.207,20.254,32.209,20.231,32.208,20.21Z",
  transform: "translate(0 0)",
  fill: "#0cd581"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16.532,
    viewBox: "0 0 16 16.532"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/sync-btn.0f6f38cc.svg";
export { SvgComponent as ReactComponent };